import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Card, CardContent } from "@mui/material";

import { styled } from "@mui/material/styles";

import Notes from "./Notes";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import Details from "./Details";
import Applications from "./Applications";

const StyledTabs = styled((props) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))({
  "& .MuiTabs-indicator": {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
  },
  "& .MuiTabs-indicatorSpan": {
    maxWidth: 40,
    width: "100%",
    backgroundColor: "#635ee7",
  },
});

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: "none",
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(1),
    color: "#C0B476",
    "&.Mui-selected": {
      color: "#000000",
    },
    "&.Mui-focusVisible": {
      backgroundColor: "red",
    },
  })
);

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function MainViewJobs() {
  const [value, setValue] = React.useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const { id } = useParams();
  const handleChange = (event, newValue) => {
    if (newValue === 1) {
      navigate(`/Jobs/${id}?tab=applications`, { state });
    }
    if (newValue === 2) {
      navigate(`/Jobs/${id}?tab=notes`, { state });
    }
    if (newValue === 0) {
      navigate(`/Jobs/${id}`, { state });
    }
    setValue(newValue);
  };

  return (
    <Card sx={{ backgroundColor: "white" }}>
      <CardContent>
        <Box
          sx={{
            maxWidth: "100%",
          }}
        >
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              background: "white",
            }}
          >
            <StyledTabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <StyledTab label="Details" {...a11yProps(0)} />
              <StyledTab label="Applications" {...a11yProps(1)} />
              <StyledTab label="Notes" {...a11yProps(2)} />
            </StyledTabs>
          </Box>
          <hr></hr>
          <CustomTabPanel value={value} index={0}>
            <Details state={state} />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <Applications />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <Notes />
          </CustomTabPanel>
        </Box>
      </CardContent>
    </Card>
  );
}
